/**
 * ColumnBadges — the small PK / FK chips shown on a column in the VQE pickers.
 * Lives in its own file so `columnPickerGroups` can stay a helper-only module
 * (react-refresh: a file should export only components or only non-components).
 */

import { cn } from '../../../../../lib/utils';

export function ColumnBadges({
  isPrimaryKey,
  isForeignKey,
}: {
  readonly isPrimaryKey: boolean;
  readonly isForeignKey: boolean;
}) {
  if (!isPrimaryKey && !isForeignKey) return null;
  return (
    <span className="flex shrink-0 items-center gap-1">
      {isPrimaryKey ? <KeyBadge kind="PK" /> : null}
      {isForeignKey ? <KeyBadge kind="FK" /> : null}
    </span>
  );
}

function KeyBadge({ kind }: { readonly kind: 'PK' | 'FK' }) {
  return (
    <span
      className={cn(
        'rounded px-1 py-0 text-[9px] font-semibold leading-tight tracking-wide',
        kind === 'PK'
          ? 'bg-amber-500/15 text-warning'
          : 'bg-sky-500/15 text-sky-600 dark:text-sky-400',
      )}
      title={kind === 'PK' ? 'Primary key' : 'Foreign key'}
    >
      {kind}
    </span>
  );
}
